import styled from "styled-components";

export const PageContainer = styled.div`
    width: calc(100%-16px);
    height: 100vh;
    padding: 16px;
    p {
        align-text: left;
    }
    @media screen and (max-width: 599px) {
        height: -webkit-fill-available;
        height: fill-available;
    }
`

export const Title = styled.div`
    
`